<template>
    <div>
        <flat-pickr v-model="row.value" :config="{ enableTime: true, time_24hr: true, dateFormat: 'Y-m-d H:i' }" :placeholder="'Pick a date and time'" required></flat-pickr>
    </div>
</template>

<script>
export default {
    props: {
        row: { type: Object, required: true }
    }
}
</script>

<style scoped>
.flatpickr-input {
    margin-bottom: 0 !important;
}
</style>
